import { render, staticRenderFns } from "./PensionUnitSelectionShowButton.vue?vue&type=template&id=50dd2e93&scoped=true&"
import script from "./PensionUnitSelectionShowButton.vue?vue&type=script&lang=ts&"
export * from "./PensionUnitSelectionShowButton.vue?vue&type=script&lang=ts&"
import style0 from "./PensionUnitSelectionShowButton.vue?vue&type=style&index=0&id=50dd2e93&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50dd2e93",
  null
  
)

export default component.exports